
export interface RouteContext {
  path: string;
  namespace: string;
  isAdmin: boolean;
  isChat: boolean;
  isDocs: boolean;
}

export const getRouteContext = (): RouteContext => {
  // Verificação de segurança para garantir que window está disponível
  if (typeof window === 'undefined') {
    return {
      path: '/',
      namespace: 'general',
      isAdmin: false,
      isChat: false,
      isDocs: false
    };
  }

  const path = window.location?.pathname || '/';
  
  return {
    path,
    namespace: path.startsWith('/paineladmin') ? 'admin' : 
              path.startsWith('/chat') ? 'chat' :
              path.startsWith('/documentos') ? 'docs' : 'general',
    isAdmin: path.startsWith('/paineladmin'),
    isChat: path.startsWith('/chat'),
    isDocs: path.startsWith('/documentos')
  };
};

export const isInRoute = (pathPrefix: string): boolean => {
  if (typeof window === 'undefined') return false;
  return window.location?.pathname?.startsWith(pathPrefix) || false;
};

export const createRouteAwareChannelName = (baseChannel: string): string => {
  const context = getRouteContext();
  return `${context.namespace}-${baseChannel}-${Date.now()}`;
};

export const shouldProcessEvent = (targetRoute?: string): boolean => {
  if (!targetRoute) return true;
  return isInRoute(targetRoute);
};

export const getRouteSpecificCacheKey = (baseKey: string): string => {
  const context = getRouteContext();
  return `${baseKey}_${context.namespace}`;
};
